function noSourceLog(...params: any[]) {
    setTimeout(() => {
        console.log.bind(console, ...params)
    })
}

export default noSourceLog